// Configuration for API and asset URLs
// Auto-detects environment and sets appropriate base URLs
const isLocalDev = typeof window !== "undefined" &&
    (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");

// API base URL - for backend API calls
// In local dev: use "/" so absolute paths work with proxy in package.json (proxy intercepts /api/*)
// In production: use /crf/ prefix (handled by server middleware)
export const API_BASED_URL = isLocalDev ? "/" : "/crf/";

// Asset base URL - for static assets bundled with React (logo, header images, etc.)
// Since homepage is "/crf" in package.json, assets are always at /crf/assets/ in both dev and production
export const ASSET_BASE = "/crf";

// App base path - for page navigation/redirects
// In local dev: use "" so paths like /login work directly
// In production: use "/crf" to match the deployment path (iitrpr.ac.in/crf/)
export const APP_BASE = isLocalDev ? "" : "/crf";
